export function useHighlightAtTheMoney() {
    const highlightAtTheMoney = (lastPrice, rows) => {
        if (typeof lastPrice == 'undefined') {
            return rows;
        }

        let largest = rows[0].raw['strikePrice'];
        let smallest = rows[rows.length - 1].raw['strikePrice'];

        rows.forEach((row) => {
            const current = row.raw['strikePrice'];

            if (current >= smallest && current < lastPrice) {
                smallest = current;
            }

            if (current < largest && current >= lastPrice) {
                largest = current;
            }
        });

        return rows.map((row) => {
            if (row.raw.strikePrice === largest || row.raw.strikePrice === smallest) {
                row.highlight = true;
            }
            return row;
        });
    };

    return {
        highlightAtTheMoney
    };
};

// export default {
//     methods: {
//         highlightAtTheMoney(lastPrice, rows) {
//             if (typeof lastPrice == 'undefined') {
//                 return rows;
//             }
//             let largest = rows[0].raw['strikePrice'];
//             let smallest = rows[rows.length - 1].raw['strikePrice'];

//             rows.forEach((row) => {
//                 const current = row.raw['strikePrice'];

//                 if (current >= smallest && current < lastPrice) {
//                     smallest = current;
//                 }

//                 if (current < largest && current >= lastPrice) {
//                     largest = current;
//                 }
//             });

//             return rows.map((row) => {
//                 if (row.raw.strikePrice === largest || row.raw.strikePrice === smallest) {
//                     row.highlight = true;
//                 }

//                 return row;
//             });
//         }
//     }
// }
